module.exports = __webpack_public_path__ + "img/T5-C-xh11.9a0a2e50.png";